// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CaseLinkIn = zod.object({
  "case_id": zod.uuid(),
  "revision": zod.int().min(1)
});

export type CaseLinkIn = zod.input<typeof CaseLinkIn>;
export type CaseLinkInOutput = zod.output<typeof CaseLinkIn>;
